import KDevice from '../../core/utils/KDevice'

export default {
  name: 'KImage',
  props: {
    src: {
      type: String,
    },
    retinaSrc: {
      type: String,
    },
    fallback: {
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    // cover, fill, contain, none, scale-down
    fit: {
      type: String,
      default: 'cover',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    // 是否开启懒加载
    lazyLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      error: false,
    }
  },
  computed: {
    clazz() {
      return {
        'km-image': true,
        'km-image--rounded': this.rounded,
        [`km-image--${this.loadStatus}`]: true,
      }
    },
    setSize() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
      }
    },
    fitStyle() {
      return {
        objectFit: this.fit,
      }
    },
    imgSrc() {
      return KDevice.isRetina ? (this.retinaSrc || this.src) : this.src
    },
    loadStatus() {
      if (this.loading) {
        return 'loading'
      } else if (this.error) {
        return 'error'
      } else {
        return 'loaded'
      }
    },
  },
  watch: {
    imgSrc() {
      this.loading = true
      this.error = false
    },
  },
  beforeMount() {
    if (!this.imgSrc) {
      this.loading = false
      this.error = true
    }
  },
  methods: {
    loadHandler(event) {
      this.error = false
      this.loading = false
      // load success
      this.$emit('load', event)
    },
    errorHandler(event) {
      this.error = true
      this.loading = false
      // load error
      this.$emit('error', event)
    },
    clickHandler(event) {
      // click
      this.$emit('click', event)
    },
    renderImg() {
      const attrs = {
        src: this.imgSrc,
      }
      if (this.lazyLoading) {
        attrs.loading = 'lazy'
      }
      const events = {
        click: this.clickHandler,
        load: this.loadHandler.bind(this),
        error: this.errorHandler.bind(this),
      }
      const data = {
        attrs,
        on: events,
        style: this.fitStyle,
      }
      return (
        <img
          class="km-image__inner"
          {...data}
        />
      )
    },
    renderError() {
      // 加载出错展示
      let renderErrorContent = null
      if (this.$scopedSlots.error) {
        renderErrorContent = this.$scopedSlots.error({})
      } else if (this.fallback) {
        renderErrorContent = (<img class="km-image__inner" src={this.fallback} style={this.fitStyle}/>)
      } else {
        renderErrorContent = (<div class="km-image__error">加载失败</div>)
      }

      return renderErrorContent
    },
  },
  render() {
    let renderContent = null

    if (this.error) {
      renderContent = this.renderError()
    } else {
      renderContent = this.renderImg()
    }

    return (
      <div class={this.clazz} style={this.setSize}>
        {renderContent}
      </div>
    )
  },
}
